import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "space-y-6"
};
const _hoisted_5 = {
  class: "space-y-4"
};
const _hoisted_6 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_7 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_8 = ["disabled"];
import { ref, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'FaqFormModal',
  props: {
    show: Boolean,
    isEdit: Boolean,
    faqData: Object
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 表单数据
    const form = reactive({
      id: null,
      question: '',
      answer: '',
      sort: 0,
      status: 1
    });

    // 提交 loading
    const submitting = ref(false);

    // 状态选项
    const statusOptions = [{
      label: '启用',
      value: 1
    }, {
      label: '停用',
      value: 0
    }];

    // 监听显示/隐藏 初始化表单
    watch(() => props.show, val => {
      if (val) {
        if (props.isEdit && props.faqData) {
          Object.assign(form, {
            id: props.faqData.id,
            question: props.faqData.question || '',
            answer: props.faqData.answer || '',
            sort: props.faqData.sort || 0,
            status: props.faqData.status ?? 1
          });
        } else {
          resetForm();
        }
      }
    });
    const resetForm = () => {
      Object.assign(form, {
        id: null,
        question: '',
        answer: '',
        sort: 0,
        status: 1
      });
    };

    // 关闭弹窗
    const handleClose = () => {
      emit('update:show', false);
    };

    // 提交
    const handleSubmit = async () => {
      // 校验必填项
      if (!form.question.trim()) {
        return ElMessage.warning('请输入问题');
      }
      if (!form.answer.trim()) {
        return ElMessage.warning('请输入答案');
      }
      submitting.value = true;
      try {
        const data = {
          question: form.question.trim(),
          answer: form.answer.trim(),
          sort: form.sort,
          status: form.status
        };
        if (props.isEdit) {
          data.id = form.id;
        }
        emit('confirm', data);
      } finally {
        submitting.value = false;
      }
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "2xl",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.isEdit ? '编辑FAQ' : '新增FAQ'), 1), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-4"
          }, "基本信息", -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 问题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.question = $event),
            type: "text",
            placeholder: "请输入问题",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.question]])]), _createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 答案 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.answer = $event),
            rows: "5",
            placeholder: "请输入答案",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.answer]])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序值", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.sort = $event),
            type: "number",
            min: "0",
            placeholder: "值越小越靠前",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[8] || (_cache[8] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])])])])])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
            onClick: handleClose,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value,
            class: "btn-primary"
          }, _toDisplayString(submitting.value ? '提交中...' : '确定'), 9, _hoisted_8)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};